export default "__VITE_PUBLIC_ASSET__5cb934a3__"